// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { isDefined } from '@shared/utils';
import { normalizeContractsNumber } from './normalize-contracts';

export const resolveTradeInput = ({
  inputType,
  contracts_number,
  assetType,
}: {
  inputType?: 'amount' | 'shares';
  contracts_number?: number | null;
  assetType?: string;
}): {
  inputType: 'amount' | 'shares';
  contracts_number?: number;
} => {
  if (inputType === 'amount') {
    return { inputType: 'amount' };
  }

  if (inputType === 'shares') {
    return {
      inputType: 'shares',
      contracts_number: normalizeContractsNumber(contracts_number ?? 0, assetType),
    };
  }

  if (isDefined(contracts_number) && contracts_number > 0) {
    return {
      inputType: 'shares',
      contracts_number: normalizeContractsNumber(contracts_number, assetType),
    };
  }

  return { inputType: 'amount' };
};
